import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { InitiateInvestmentOrderRequest } from '@cash-web/shared-util-protos/squareup/franklin/investing.pb'
import { InitiateInvestmentOrderResponse } from '@cash-web/shared-util-protos/squareup/franklin/investing.pb'

export const initiateInvestmentOrder = (request: InitiateInvestmentOrderRequest, options?: CashRequestOptions) =>
  post<InitiateInvestmentOrderRequest, InitiateInvestmentOrderResponse>(
    '/2.0/cash/initiate-investment-order',
    request,
    { ...options, rejectOnError: true }
  )
